import * as React from 'react';
import "../../../assets/img/tip_win.gif";
import "../../../assets/img/tip_cashout.gif";
import "../../../assets/img/tip_loose.gif";
import "../../../assets/img/tip_none.gif";
import "../../../assets/img/tip_cancel.gif";
import "../../../assets/img/icon_cashout1x_white.png";
import "../../../assets/img/qr-code.png";


export const Img: React.FC<React.ImgHTMLAttributes<{}>> = (props) => {
    const assetRoot = "../../../img/";
    return <img {...props} src={`${assetRoot}${props.src}`} />
}